import { Component, EventEmitter, Output } from "@angular/core";
import { OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from 'rxjs';


import { config } from "../../../../../config/index";

import { CommunicationMenuService } from "./communication-menu.service";
import { SharedService } from "../../services/shared.service";
import { SessionStorageService } from "../../services/session-storage.service";
import { SnackbarService } from "../../../shared/services/snackbar.service";

@Component({
	selector: "communication-menu",
	template: require('./communication-menu.component.html'),
	styles: [require('./communication-menu.component.less')],
	providers: [
		SharedService,
		SessionStorageService,
		CommunicationMenuService,
		SnackbarService,
	],
	preserveWhitespaces: true,
})
export class CommunicationMenuComponent implements OnInit {
	@Output() communicationMenuEvent: EventEmitter<any> = new EventEmitter<
		any
	>();
	@Output() isInnerSidebarOpen: EventEmitter<any> = new EventEmitter<any>();

	private _role = config.role;
	private _userRole: string;
	private locatManager: string;
	private cooAdmin: string;
	private ctAdmin: string;
	package = config.package;
	subscription: any;
	vcEnabled: any = config.va_enabled;
	isMainSidebarOpen: boolean = false;
	isSidebarOpen: boolean = config.followUpSideBarOpen;
	isSidebarOvarlap: boolean = false;

	apiSubscription: Subscription;

	constructor(
		private _sharedService: SharedService,
		private _communicationMenuService: CommunicationMenuService,
		private _mdlSnackbarService: SnackbarService,
		private _sessionStorageService: SessionStorageService,
		private _router: Router
	) {}

	/** Fetching user role **/
	userRoleFetch = () => {
		this._sessionStorageService.readItem(this._role).then((data: any) => {
			this._userRole = data.role;
		});
	};

	navigate = (path: any) => {
		config.followUpSideBarOpen = this.isSidebarOpen;
		this._router.navigate([path]);
	};

	searchItem = (searchKey: any) => {
		this.communicationMenuEvent.emit(searchKey);
	};

	checkVcEnabled() {
		this.apiSubscription = this._communicationMenuService.getUserStatus().subscribe(
			(res: any) => {
				this.vcEnabled = res.data.vc_enabled;
				config.va_enabled = this.vcEnabled;
				if (
					this.vcEnabled === false &&
					this._router.url === "/virtual-consultation-communications"
				) {
					this._router.navigate(["home/dashboard"]);
				}
			},
			(error: any) => {
				this._router.navigate(["home/dashboard"]);
				this._mdlSnackbarService.showSnackbar("SOMETHING_WENT_WRONG", 'error');
			}
		);
	}
	collapseSidebar() {
		this.isSidebarOpen = !this.isSidebarOpen;
		this.isInnerSidebarOpen.emit(this.isSidebarOpen);
	}

	hoverSidebar(type: string) {
		if (!this.isSidebarOpen) {
            this.isSidebarOvarlap = type === "enter";
		}
	}

	ngOnInit() {
		setTimeout(() => {
			this.isInnerSidebarOpen.emit(this.isSidebarOpen);
		}, 0);
		this.checkVcEnabled();
		this.locatManager = config.location_manager;
		this.cooAdmin = config.coo_admin;
		this.ctAdmin = config.ct_admin;
		this.userRoleFetch();
		this._sessionStorageService.readItem(this.package).then((data: any) => {
			this.subscription = data.package;
		});
	}

	ngOnDestroy() {
        this.apiSubscription?.unsubscribe();
    }

}
